// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.application.data.env

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadOnly
import org.evoleq.optics.lens.Lens

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class Environment(
    @ReadOnly val set: Boolean = false,
    @ReadOnly val type: String = "DEV",
    @ReadOnly val frontendUrl: String = "http://localhost",
    @ReadOnly val frontendPort: Int = 8080,
    @ReadOnly val backendUrl: String = "http://localhost",
    @ReadOnly val backendPort: Int = 8081,
)

/**
 * Autogenerated ReadOnly Lens.
 * Read [Environment.set]
 */
@ReadOnly val set: Lens<Environment, Boolean> by lazy{ Lens(
    get = {whole -> whole.set},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [Environment.type]
 */
@ReadOnly val type: Lens<Environment, String> by lazy{ Lens(
    get = {whole -> whole.type},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [Environment.frontendUrl]
 */
@ReadOnly val frontendUrl: Lens<Environment, String> by lazy{ Lens(
    get = {whole -> whole.frontendUrl},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [Environment.frontendPort]
 */
@ReadOnly val frontendPort: Lens<Environment, Int> by lazy{ Lens(
    get = {whole -> whole.frontendPort},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [Environment.backendUrl]
 */
@ReadOnly val backendUrl: Lens<Environment, String> by lazy{ Lens(
    get = {whole -> whole.backendUrl},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [Environment.backendPort]
 */
@ReadOnly val backendPort: Lens<Environment, Int> by lazy{ Lens(
    get = {whole -> whole.backendPort},
    set = {{it}}
) }
